import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { Redirect } from "react-router-dom";

import { AppConfig } from "../../configs/config";
import { useMyContext } from "../../contexts/StateHolder";
import { getUser, getPackages, getPaymentMethods } from "../../scripts/dataHandlers";
import { useGetUserSubscription } from "../../features/user/api/use-get-user-subscription";

import PackagesView from "./Views/PackagesView";
import PaymentMethodsView from "./Views/PaymentMethodsView";

import classes from "./PurchaseFlow.module.css";
import settings from "../../configs/config_settings.json";

export const PurchaseFlowSubscription = (props) => {
	const { organizationId } = settings.organization;
	const { language } = settings;

	const { data, isLoading } = useGetUserSubscription();

	//this controls which bottom page view is shown
	const [pageState, setPageState] = useState("packages");

	//Shopping categories are not yet used. Maybe never will, but keep it here as a comment until we are sure one way or another
	const {
		setPackages,

		setSelectedPackage,
		paymentMethods,
		setPaymentMethods,
		user,
		setUser,
	} = useMyContext();

	const [cookies] = useCookies("");

	// Holder for profileData
	const [profileData, setProfileData] = useState({
		firstName: "",
		lastName: "",
		phone: "",
		email: "",
		city: "",
		country: "",
		countryId: "",
		address: "",
		postalCode: "",
		regionId: "",
		buyerProducts: [],
	});

	// Fetch userdata from API and set it to profileData
	useEffect(() => {
		async function getUserData() {
			try {
				const response = await getUser(cookies?.user?.userToken, organizationId);

				if (response.status === 200) {
					const newData = {
						firstName: response.data.firstName,
						lastName: response.data.lastName,
						phone: response.data.phone,
						email: response.data.emailAddress,
						city: response.data.city,
						country: response.data.country,
						countryId: response.data.countryId,
						address: response.data.address,
						postalCode: response.data.postalCode,
						regionId: response.data.regionId,
						buyerProducts: response.data.buyerProducts,
					};
					setProfileData({ ...newData });
					if (user.email !== response.data.emailAddress) {
						let modifiedUser = { ...user };
						modifiedUser.eMail = response.data.emailAddress;
						setUser({ ...modifiedUser });
					}
				} else {
					console.log("something wrong with request");
				}
			} catch (err) {
				console.log(err);
			}
		}

		if (organizationId && organizationId > 0 && user && user.userId !== 0) {
			getUserData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [language, organizationId]);

	//Fetching organizations packages and payment methods and I know this could be united with the effect above (and probably should)
	useEffect(() => {
		async function getPackagesData() {
			try {
				const responseData = await getPackages(
					organizationId,
					language,
					undefined,
					undefined,
					AppConfig.recurringShoppingCategoryId
				);

				if (responseData.status === "ok" && typeof responseData.packages !== "undefined") {
					setPackages(responseData.packages);
				}
			} catch (err) {
				console.log(err);
			}
		}

		async function getPaymentMethodsData() {
			try {
				const responseData = await getPaymentMethods(organizationId);

				if (responseData.status === "ok" && typeof responseData.paymentMethods !== "undefined") {
					setPaymentMethods(responseData.paymentMethods);
				}
			} catch (err) {
				console.log(err);
			}
		}
		if (organizationId && organizationId > 0) {
			getPackagesData();
		}

		if (organizationId && organizationId > 0) {
			getPaymentMethodsData();
		}

		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [organizationId, language]);

	//used when user selects the package
	const selectPackage = (pkg) => {
		setPageState("payment");
		setSelectedPackage(pkg);
	};

	//successful purchase and move to bank url. Doesn't really need to be here. Could move to paymentMethods view.
	const buyPackageSuccess = (newUrl) => {
		window.location.replace(newUrl);
	};

	if (!isLoading && data?.isUserSubscribed) return <Redirect to="/" />;

	return (
		<div className={classes.packageMain}>
			{pageState === "packages" && (
				<PackagesView
					buyButtonAction={selectPackage}
					profileData={profileData}
					paymentMethods={paymentMethods}
				/>
			)}
			{pageState === "payment" && (
				<PaymentMethodsView
					paymentMethods={paymentMethods}
					buyPackageSuccess={buyPackageSuccess}
					settings={props.settings}
				/>
			)}
		</div>
	);
};
